export class CommandAddress {
  Id: string;
  StreetName: string;
  Number: string;
  Suffix: string;
  LomKey: string;
  BuildingLomKey: string;

  get FullAddress() {
    let fullAddress = "";
    if (this.StreetName) fullAddress += this.StreetName;
    if (this.Number) fullAddress += " " + this.Number;
    if (this.Suffix) fullAddress += " " + this.Suffix;
    return fullAddress;
  }

  constructor(address: {
    id?: string;
    streetName?: string;
    number?: string;
    suffix?: string;
    lomKey?: string;
    buildingLomKey?: string;
  }) {
    this.Id = address.id;
    this.StreetName = address.streetName;
    this.Number = address.number;
    this.Suffix = address.suffix;
    this.LomKey = address.lomKey;
    this.BuildingLomKey = address.buildingLomKey;
  }
}
